import BreadCrumbsBlog from '../BreadCrumbsBlog/BreadCrumbsBlog';
import styles from './wpPost.module.scss';
import React from 'react';
import { sanitizeBlogHtml } from '@/utils/sanitizeBlogHtml';

type Post = {
  id: number;
  slug: string;
  title: string;
  content: string;
  featured_media: string | null;
};

const WpPost = ({ post }: { post: Post }) => {
  if (!post) return <p>Loading…</p>;
  const sanitizedTitle = sanitizeBlogHtml(post.title, 'preview');
  const sanitizedContent = sanitizeBlogHtml(post.content, 'article');

  return (
    <section className={styles.wpPost}>
      <div className="container">
        <BreadCrumbsBlog item={post?.title} />
        <h1
          className={styles.title}
          dangerouslySetInnerHTML={{ __html: sanitizedTitle }}
        ></h1>
        <div
          dangerouslySetInnerHTML={{ __html: sanitizedContent }}
          className={styles.content}
        />
      </div>
    </section>
  );
};

export default WpPost;
